export const calculateTotalOrderQuantity = (orderLines: { orderQuantity?: number }[] = []): number => {
  return orderLines.reduce((sum, line) => sum + Number(line?.orderQuantity || 0), 0);
};
